import LocalSettingsProto from "../../core/gd/settings/local-settings/local-settings-v4";
import {MAIN_MENU_DEFAULT_WIDTH} from "../navigation/@const";


export default class LayoutLocalSettings extends LocalSettingsProto {

    public forcedMin : boolean      // if true it means user minimized the menu
    private _menuWidth : number

    constructor() {
        super('layout');

        const values        = this._readFromLocalStorage();

        this.forcedMin      = _.get(values, 'forcedMin', false);
        this._menuWidth      = _.get(values, 'menuWidth', MAIN_MENU_DEFAULT_WIDTH);
    }

    get menuWidth() {
        return this._menuWidth
    }

    set menuWidth(width:number) {
        this._menuWidth = width
        this.save()
    }


    toObject() {
        return {
            forcedMin:          this.forcedMin,
            menuWidth:          this.menuWidth,
        };
    }

}
